import { render } from "./Marketplace.vue?vue&type=template&id=e401524c&scoped=true&ts=true"
import script from "./Marketplace.vue?vue&type=script&lang=ts"
export * from "./Marketplace.vue?vue&type=script&lang=ts"

import "./Marketplace.vue?vue&type=style&index=0&id=e401524c&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e401524c"]])

export default __exports__